// purchaseDetailedReportSlice.js
import { createSlice } from "@reduxjs/toolkit";
 

const initialState = {
  data: {
    business: null,
    buys: [],
    groupedData: [],
    summary: {
      totalSales: 0,
      totalTransactions: 0
    }
  },
  loading: false,
  error: null,
};

const purchaseDetailedReportSlice = createSlice({
  name: "purchaseDetailedReport",
  initialState,
  reducers: {
    purchaseReportRequest(state) {
      state.loading = true;
      state.error = null;
    },
    purchaseReportSuccess(state, action) {
      state.loading = false;
      state.data = action.payload.data;
    },
    purchaseReportFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetPurchaseReport(state) {
      state.loading = false;
      state.error = null;
      state.data = initialState.data;
    }
  },
});

export const {
  purchaseReportRequest,
  purchaseReportSuccess,
  purchaseReportFailure,
  resetPurchaseReport,
} = purchaseDetailedReportSlice.actions;

export default purchaseDetailedReportSlice.reducer;

